import { NavigationSubItem } from "../navigation-item"

export class DesignTypographySubItem extends NavigationSubItem {
  readonly id = "design-typography"
  readonly label = "Typography"
  readonly href = "/design/typography"
  readonly iconName = "design-typography-icon"
  readonly isExternal = false
  readonly tabs = []
}
